import React from 'react';
import Logo from './Logo';
import './LoadingScreen.css';

const LoadingScreen = ({ message = 'Loading...' }) => (
  <div className="loading-screen">
    <div className="loading-screen__panel" role="status" aria-live="polite">
        <Logo variant="named" size={132} alt="Crew Core" />
        <div className="loading-screen__loader" aria-hidden="true">
          <span className="loading-screen__ring" />
        </div>
        <p>{message}</p>
    </div>
  </div>
);

export default LoadingScreen;
